import { Admin, adminFactory } from '@/types/admin';
import { Organization, organizationFactory } from '@/types/organization';

export type AdminRole = 'member' | 'manager';

export const adminRoles: AdminRole[] = ['member', 'manager'];

export type Affiliation = {
  admin: Admin;
  organization: Organization;
  role: AdminRole;
};

const defaultAffiliation: Affiliation = {
  admin: adminFactory(),
  organization: organizationFactory(),
  role: 'member',
};

export const affiliationFactory = (affiliationAttrs?: {
  [P in keyof Affiliation]?: Affiliation[P];
}): Affiliation => ({
  ...defaultAffiliation,
  ...affiliationAttrs,
});
